<template>
    <div ref="flashAlertContainer">
        <FlashAlert :message="flashMessage" v-if="flashMessage" :key="flashMessageId"></FlashAlert>
    </div>
</template>

<script>
import eventBus from "./eventBus";
import FlashAlert from "./FlashAlert.vue";

export default {
    components: {
        FlashAlert,
    },

    data() {
        return {
            flashMessage: null,

            // Make sure a new key is generated each time a new message is received,
            // so that vue creates a new flash alert component instance to reset the state (user can hide the alert)
            flashMessageId: 1,
        }
    },

    created() {
        eventBus.subscribe('flashMessage', this.onFlashMessageReceived);
    },

    beforeDestroy() {
        eventBus.unsubscribe('flashMessage', this.onFlashMessageReceived);
    },

    methods: {
        onFlashMessageReceived(message) {
            this.flashMessageId = 'fm_' + (new Date()).getTime() + '_' + Math.floor(Math.random() * 1000);
            this.flashMessage = message;
            this.$nextTick(() => {
                this.$refs.flashAlertContainer.scrollIntoView({behavior: 'smooth'});
            });
        }
    }
}
</script>